import type { OfferCheckoutRequest } from '@/data/catalog/offer/interfaces';
import type { CreateRegistrationBody } from '@/data/courses/registration/interfaces';

export const redactRegistrartionPayloadData = (
  data: CreateRegistrationBody
) => {
  return {
    cep: data.full_address.postal_code,
    city: data.full_address.city,
    state: data.full_address.state,
    hasNumber: data.full_address.number ? true : false,
    cpf: data.cpf?.slice(0, 5) + '******',
  };
};

export const redactCheckoutPayloadData = (data: OfferCheckoutRequest) => {
  return {
    cep: data.zip_code,
    city: data.city,
    state: data.state,
    hasNumber: data.address_number ? true : false,
    cpf: data.document?.slice(0, 5) + '******',
    paymentMethod: data.payment_method,
  };
};
